import { UpstreamError } from './interfaces'

export default class NotFoundError extends Error {
    redirectURL?: string
    constructor({ message, redirectURL }: UpstreamError) {
        super(`Requested resource not found: ${message}`)
        this.redirectURL = redirectURL
    }
}
